import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  queryKey?: string;

  PaginaAtual?: number;
  TotalItensRetorno?: number;
  PalavrasChave?: string;
  idEquipe?: number;
  idCampanha?: number;
}
export function useGetListarCampanhas(props: Props) {
  const hasPalavrasChave = props.PalavrasChave
    ? `&PalavrasChave=${props.PalavrasChave}`
    : "";
  const hasIdEquipe = props.idEquipe ? `&idEquipe=${props.idEquipe}` : "";
  const hasIdCampanha = props.idCampanha
    ? `&idCampanha=${props.idCampanha}`
    : "";
  const fetchData = async () => {
    const LISTAR_DESTAQUES = `${leadsWebEnviroment}/common/campanha/listar-campanhas/v1?${hasPalavrasChave}&PaginaAtual=${props.PaginaAtual}&TotalItensRetorno=${props.TotalItensRetorno}${hasIdEquipe}${hasIdCampanha}`;
    const response = await instance.get(LISTAR_DESTAQUES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };

  const query = useQuery({
    enabled: true,
    queryFn: fetchData,
    queryKey: [props.queryKey || "listar_campanhas"],
    refetchOnWindowFocus: false,
  });

  return query;
}
